export default {
  PERMISSION_ACTIONS (state, value) {
    state.actions = value
  },
  PERMISSION_MODELS (state, value) {
    state.models = value
  }
}
